export default __webpack_public_path__ + "static/media/bgsfgif.d4177d65.gif";